import { render } from "./RecommendView.vue?vue&type=template&id=2e59970e&scoped=true"
import script from "./RecommendView.vue?vue&type=script&lang=js"
export * from "./RecommendView.vue?vue&type=script&lang=js"

import "./RecommendView.vue?vue&type=style&index=0&id=2e59970e&scoped=true&lang=scss"

import exportComponent from "D:\\projects\\APP\\vue3-ewshop\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e59970e"]])

export default __exports__